import { METHOD } from "../lib/constants";

function MethodologyStep({ step, index }) {
    const isFirst = index === 0;
    const isLast = index === 3;
    return (
        <div
            className={`reveal py-8 lg:py-12 lg:px-8 ${
                isFirst ? "lg:pl-0" : "lg:border-l border-slate-200"
            } ${isLast ? "lg:pr-0" : ""} ${
                index > 0 ? "border-t lg:border-t-0 border-slate-200" : ""
            }`}
            data-testid={`method-step-${index + 1}`}
        >
            <p className="font-display text-4xl lg:text-5xl text-slate-200 font-light leading-none mb-4 lg:mb-6 tracking-tighter">
                {step.n}
            </p>
            <p className="text-base text-[#0B132B] leading-snug">
                {step.body}
            </p>
        </div>
    );
}

export function Methodology() {
    return (
        <section
            id="methode"
            className="border-b border-slate-200"
            data-testid="methodology-section"
        >
            <div className="mx-auto max-w-7xl px-6 md:px-12 lg:px-16 py-14 md:py-24">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-10 md:mb-14">
                    <div className="lg:col-span-4">
                        <p className="reveal text-xs tracking-[0.18em] uppercase text-slate-500 mb-4">
                            03 — Démarche
                        </p>
                        <h2
                            className="reveal font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#0B132B] font-medium leading-[1.05]"
                            data-testid="method-title"
                        >
                            Comment ça se passe
                        </h2>
                    </div>
                    <div className="lg:col-span-7 lg:col-start-6">
                        <p
                            className="reveal text-base lg:text-lg text-slate-600 leading-relaxed max-w-xl"
                            data-testid="method-intro"
                        >
                            Quatre étapes simples, sans cadre rigide. Le but
                            est de produire des décisions concrètes que vous
                            pourrez appliquer.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-t border-slate-200">
                    {METHOD.map((step, i) => (
                        <MethodologyStep
                            key={step.n}
                            step={step}
                            index={i}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
}
